<div class="image-container" [ngClass]="{ 'edit-mode-enabled': editEnabled }">
  <div class="row asset-image-header">
    <h4 class="col-10 asset-image-title">{{ title ?? '' | translate}}</h4>
    <div class="collapse-arrow col-2">
      <button class="action-button action-button-submenu" (click)="imageSectionExpanded = true"
        *ngIf="!imageSectionExpanded">

        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <button class="action-button action-button-submenu" (click)="imageSectionExpanded = false"
        *ngIf="imageSectionExpanded">

        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

    </div>
  </div>
  <ng-container *ngIf="imageSectionExpanded">
    <div *ngIf="image" @slideToggle>
      <img [src]="image" (click)="onImageClick()" data-bs-toggle="modal" [attr.data-bs-target]="'#'+imageId"
        alt="Uploaded image" />
    </div>

    <div *ngIf="(editEnabled)" @slideToggle>
      <input [id]="inputId" hidden type="file" (change)="onFileSelected($event)" [disabled]="!permission" />
      <label [for]="inputId" class="replace-image-label" [ngClass]="{ 'disabled-label': !permission }">
        <img *ngIf="!image" src="../../../../assets/missing_image.png" alt="Missing image" />
        <ng-container *ngIf="editEnabled && image">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="#6c757d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-edit">
            <title>Replace this photo</title>
            <path d="M12 20h9"></path>
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 0l1 1a2.121 2.121 0 0 1 0 3L7 21H3v-4L16.5 3.5z"></path>
          </svg>
        </ng-container>
      </label>
    </div>
  </ng-container>

</div>